import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { pendingTasksReducer } from 'react-redux-spinner'
import { i18nReducer } from 'react-redux-i18n'
import app from './app'
import login from './login'

export default combineReducers({
  routing: routerReducer,
  pendingTasks: pendingTasksReducer,
  app,
  login,
  i18n: i18nReducer,
})



// WEBPACK FOOTER //
// ./src/ducks/index.js